module.exports = __webpack_public_path__ + "img/question16c2.5f33d763.png";